import { render, staticRenderFns } from "./UiBoxShadows.vue?vue&type=template&id=11c30990&"
import script from "./UiBoxShadows.vue?vue&type=script&lang=js&"
export * from "./UiBoxShadows.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports